<agr-dialog (alt)="alt()" (cancel)="cancel()" [data]="data">
  <div class="spacing--margin-horizontal spacing--margin-top">
    <div class="spacing--margin-bottom">
      <div class="flex--row flex--wrap">
        <div class="flex--column spacing--margin-left field-width">
          <span class="text--small text--gray label">
            {{ 'arrival-date' | translate }}
          </span>
          <span
            class="text--small text--bold label"
            data-test="wdo-registration-overview__arrivaldate"
          >
            {{ data.cycle.cycleDate | agrDate }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left field-width">
          <span class="text--small text--gray label">
            {{ 'concept' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.cycle.concept.name }}
          </span>
        </div>

        <div class="flex--column spacing--margin-left field-width">
          <mat-label class="text--small text--gray">
            {{ 'wdo-registration.select-barn' | translate }}
          </mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            data-test="wdo-registration-overview__select-barn"
            [(ngModel)]="selectedBarnId"
            (ngModelChange)="setSelectedBarn(selectedBarnId)"
            [placeholder]="'wdo-registration.select-barn-placeholder' | translate"
          >
            <mat-option *ngFor="let barn of barns" [value]="barn.id">
              {{ barn.name }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>

  <div class="spacing--margin-top">
    <agr-summary-card
      [title]="'wdo-registration-overview.weekly-registrations' | translate"
      [canExpand]="true"
      *ngIf="this.hasWeekRows"
    >
      <agr-table
        [config]="weekTableConfig"
        data-test="wdo-registration-overview__week-table"
      ></agr-table>
    </agr-summary-card>
  </div>
  <div class="spacing--margin-top">
    <agr-summary-card
      [title]="'wdo-registration-overview.daily-registrations' | translate"
      [canExpand]="true"
      *ngIf="this.hasDayRows"
    >
      <agr-table
        [config]="dayTableConfig"
        data-test="wdo-registration-overview__day-table"
      ></agr-table>
    </agr-summary-card>
  </div>
  <div class="spacing--margin-top" *ngIf="!this.hasDayRows && !this.hasWeekRows">
    <div class="notification notification-warning">
      <mat-icon>warning</mat-icon>
      <b>{{ 'wdo-registration-overview.no-observations-found.title' | translate }}</b>
      <div>{{ 'wdo-registration-overview.no-observations-found.message' | translate }}</div>
    </div>
  </div>
</agr-dialog>
